/**
 * SettingsSaveBar — bottom action bar for the profile settings page.
 *
 * "Cancel" navigates back to the profile view discarding edits; "Save & View"
 * persists then navigates to the profile view. Replaces the old top-of-card
 * Save button + the duplicate bottom Save Changes button.
 *
 * @route /profile/edit
 * @parent CommunityProfileSettingsForm
 */

import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../../Button/index'
import { useTranslatedText } from '../../../../../StaticText/StaticTextContext'

const CLS = 'community-profile-settings'

export interface SettingsSaveBarProps {
  onCancel: () => void
  onSaveAndView: () => void
  saving: boolean
}

function SettingsSaveBar ({
  onCancel,
  onSaveAndView,
  saving,
}: SettingsSaveBarProps) {
  const cancelText = useTranslatedText({ keys: ['cancel'] })
  const savingText = useTranslatedText({ keys: ['saving'] })
  const saveAndViewText = useTranslatedText({ keys: ['saveAndView'] })

  return (
    <div className={`${CLS}__save-bar`}>
      <Button
        type={BUTTON_TYPES.GHOST}
        className={`${CLS}__cancel-btn`}
        onClick={onCancel}
        disabled={saving}
      >
        {cancelText}
      </Button>
      <Button
        type={BUTTON_TYPES.PRIMARY}
        className={`${CLS}__save-view-btn`}
        onClick={onSaveAndView}
        disabled={saving}
        aria-busy={saving}
      >
        {saving ? savingText : saveAndViewText}
      </Button>
    </div>
  )
}

export default SettingsSaveBar
